import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupervisorReview = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 37,
	viewBox: "0 0 38 37",
	width: 38,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m38 36.5-38-38.5h38z",
		fill: "current"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m31.875 6.62452v5.62498c-.0003.0534-.012.1061-.0343.1546s-.0547.0917-.0951.1267c-.7162.6201-1.4011.8437-2.054.8437-.8864 0-1.7143-.4097-2.4844-.7898-1.2445-.6164-2.3264-1.1503-3.5822-.1585v2.0733c0 .0995-.0395.1949-.1098.2652-.0704.0703-.1657.1098-.2652.1098s-.1948-.0395-.2652-.1098c-.0703-.0703-.1098-.1657-.1098-.2652v-7.87498c.0004-.05342.0121-.10615.0345-.15466.0224-.0485.0549-.09166.0953-.12659 1.6875-1.46156 3.2021-.71297 4.5371-.0525 1.2862.63656 2.4014 1.18688 3.7125.0525.0542-.04697.1207-.07743.1917-.08774.0709-.01032.1434-.00007.2087.02953.0653.02961.1208.07732.1598.13748.039.06017.06.13027.0604.20198z",
		fill: "white"
	})]
});
export default SvgSupervisorReview;
